import { DecretTertiaireDiagnostic } from '../../../components/tools/DecretTertiaireDiagnostic';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('entreprises', 'decret-tertiaire')!;

export default function EntreprisesDecretTertiairePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/entreprises"
        backLabel="Espace entreprises"
        duration="3 min"
      >
        <DecretTertiaireDiagnostic lockedAudience="entreprises" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace entreprises', url: 'https://solutionecofrance.fr/entreprises' },
          { name: 'Décret Tertiaire', url: 'https://solutionecofrance.fr/entreprises/decret-tertiaire' },
        ]}
      />
    </>
  );
}
